import { toast } from "react-toastify";
import ApiURL from "./ApiUrl";
import AppApi from "./AppApi";
import ErrorMessageFormat from "../error/ErrorMessageFormat";
export class DocumentationApi {
  constructor(private api: AppApi) {}

  async getDocumentation(queryId: number) {
    try {
      const res = await fetch(`${ApiURL()}documentation?queryId=${queryId}`, {
        ...this.api.auth.properties("GET", true),
      });
      if (res.ok) {
        const data = await res.json();
        return data;
      } else {
        const errorData = await res.json();
        toast.error(ErrorMessageFormat(errorData), { autoClose: false });
      }
    } catch (err) {
      toast.error(`Request failed: ${err}.`);
    }
  }
}
